<span class="loading" *ngIf="loading">
  <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bardashboard></app-side-menu-bardashboard>
<div class="main-content">
  <!-- <div class="heading">
    <label class="heading-text">Status Report</label>
  </div> -->
  <div class="filters" [formGroup]="qamatrixDashboardForm">
    <div class="filtersDropdownSmall">
      <!-- <select formControlName="YearlyControl" class="datepickerwidth" (change)="clearData()">
        <option *ngFor="let yearly of yearlySelect">{{yearly}}</option>
      </select> -->
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Semester</mat-label>
        <mat-select formControlName="YearlyControl" (selectionChange)="clearData()">
          <mat-option *ngFor="let yearly of yearlySelect" [value]="yearly">{{yearly}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filtersDropdownSmall">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Year</mat-label>
        <mat-select formControlName="YearControl" (selectionChange)="clearData()">
          <mat-option *ngFor="let year of yearSelect" [value]="year">{{year}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <select formControlName="YearControl" class="datepickerwidth" (change)="clearData()">
        <option *ngFor="let year of yearSelect">{{year}}</option>
      </select> -->
    </div>
    <!-- Cluster -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select BU/GBU Sub-Region</mat-label>
        <mat-select #clusterControl [(ngModel)]="clusterdefault"  formControlName="clusters" multiple (selectionChange)="loadSite()">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let clus of cluster" (click)="optionClick()" [disabled]="disableCluster" [value]="clus">
            {{clus}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Site -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Site</mat-label>
        <mat-select #siteControl [(ngModel)]="sitedefault" formControlName="sites" multiple (selectionChange)="loadBigCategory()">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
            {{fact}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Big Category -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Business Group</mat-label>
        <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
           formControlName="bigcategories"
          multiple (selectionChange)="clearData()">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="bigCategoryAllSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleBigCategoryAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filtersDropdown">
      <button class="btn-qm" color="primary" (click)="generateReport()">
        Generate Report
      </button>
    </div>
    <div class="alert alert-danger failMsg" *ngIf="showValidationMessage">
      {{ValidationMsg}}
    </div>
    <div class="alert alert-success failMsg" *ngIf="showSuccess">
      {{recordsinserteddetails}} <br />
      {{recordupdateddetails}}
    </div>
  </div>
  <br/><br/>
  <div class="project-status-content" [hidden]="!showProjectStatusContent ">
  <div [hidden]="!dataAvailable">
    <div class="filters filters-wrapper-projectstatus" [formGroup]="qamatrixDefects">
      <!--Cluster-->
      <div class="filtersDropdown1">
        <mat-form-field appearance="fill" class="mat-minsize-dropdown">
          <mat-label>Select BU/GBU Sub-Region</mat-label>
          <mat-select #clusterFilter [(ngModel)]="clusterfilterdefault"
            matTooltip="{{ clusterFiltertooltip.join('\n') }}" matTooltipPosition='above'
            formControlName="clusterFilter" multiple (selectionChange)="filterDatabyConditionchange()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="clusterFilterSelectedAll" [ngModelOptions]="{standalone: true}"
                (change)="toggleAllClusterFilterSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let clus of clusterfilter" (click)="optionclusterFilterClick()" [value]="clus">{{clus}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!--Sites-->
      <div class="filtersDropdown1">
        <mat-form-field appearance="fill" class="mat-minsize-dropdown">
          <mat-label>Select Site</mat-label>
          <mat-select #siteFilter [(ngModel)]="sitefilterdefault" matTooltip="{{ siteFiltertooltip.join('\n') }}"
            matTooltipPosition='above' formControlName="siteFilter" multiple
            (selectionChange)="filterDatabyConditionchange()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="siteFilterSelectedAll" [ngModelOptions]="{standalone: true}"
                (change)="toggleAllSiteFilterSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let fact of sitefilter" (click)="optionsiteFilterClick()" [value]="fact">{{fact}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Big Category -->
      <div class="filtersDropdown1">
        <mat-form-field appearance="fill" class="mat-medsize-dropdown">
          <mat-label>Select Business Group</mat-label>
          <mat-select #bigCategoryFilter [(ngModel)]="bigcategoryfilterdefault"
            matTooltip="{{ bigcategoryFiltertooltip.join('\n') }}" matTooltipPosition='above'
            formControlName="bigCategoryFilter" multiple (selectionChange)="filterDatabyConditionchange()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="bigCategoryFilterSelectedAll" [ngModelOptions]="{standalone: true}"
                (change)="toggleAllBigCategoryFilterSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let categ of bigcategoryfilter" (click)="optionBigCategoryFilterClick()"
              [value]="categ">{{categ}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- User -->
      <div class="filtersDropdown1">
        <mat-form-field appearance="fill" class="mat-minsize-dropdown">
          <mat-label>Select User</mat-label>
          <mat-select #userFilter [(ngModel)]="userfilterdefault" formControlName="userFilter"
            matTooltip="{{ userFiltertooltip.join('\n') }}" multiple (selectionChange)="filterDatabyConditionchange()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="userFilterSelectedAll" [ngModelOptions]="{standalone: true}"
                (change)="toggleAlluserFilterSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let prod of userfilter" (click)="optionUserFilterClick()" [value]="prod">{{prod}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Export Button -->
      <div class="filtersDropdown1">
        <button type="button" class="btn-qm" (click)="exportExcel()">
          <i class="export-icon"></i>  Export Excel
        </button>
      </div>
    </div>
    <!-- </div> -->

    <!-- </div>
      </div>
    </div> -->
  </div>
  <div [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
    <div *ngIf="nofiltereddata" class="records">{{noRecords}}</div>
    <div class="example-container mat-elevation-z8" [hidden]="nofiltereddata" [ngClass]="isAuthorized ? '' : 'newHeight'">
      <mat-paginator #paginator 
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons>
      </mat-paginator>
      <table mat-table [dataSource]="dataSource" [hidden]="nofiltereddata">
        <!-- Modification Date Column -->
        <ng-container matColumnDef="Modification Date">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Created Date </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <!-- <span>{{element.createddate}}</span> -->
            <span>{{element.createddate }}</span>
          </td>
        </ng-container>
        <!-- Start Date Column -->
        <!-- <ng-container matColumnDef="Start Date">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Start Date </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
              <span>{{element.startdate}}</span>
            </td>
        </ng-container> -->
        <!-- End Date Column -->
        <!-- <ng-container matColumnDef="End Date">
            <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> End Date </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
              <span>{{element.enddate}}</span>
            </td>
        </ng-container> -->
        <!-- Cluster Column -->
        <ng-container matColumnDef="BU/Sub Region">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Sub Region </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.subregion}} </td>
        </ng-container>
        <!-- Site Column -->
        <ng-container matColumnDef="Site">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Site </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.sites}} </td>
        </ng-container>
        <!-- Big Category Column -->
        <ng-container matColumnDef="Business Group">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Business Group </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.businessgroup}} </td>
        </ng-container>
        <!-- Defect MODE Column -->
        <ng-container matColumnDef="Loss Tree">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Loss Tree </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element">
            <span>{{element.defectmodeaggregation}}</span>
          </td>
        </ng-container>
        <!-- level 0 Column -->
        <ng-container matColumnDef="Level0">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Level 0 </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.level0}} </td>
        </ng-container>
        <!-- 4Ms Column -->
        <ng-container matColumnDef="4Ms">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> 4Ms </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.fourms}} </td>
        </ng-container>
        <!-- Product Column -->
        <!-- <ng-container matColumnDef="Product">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.product}} </td>
        </ng-container> -->
        <!-- RecordID Column -->
        <ng-container matColumnDef="RecordID">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> RecordID </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.recordid}} </td>
        </ng-container>
        <!-- Product line Column -->
        <ng-container matColumnDef="Production Line">
          <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Production line </th>
          <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.productionline}} </td>
        </ng-container>
        <!-- DPI Total Column -->
        <ng-container matColumnDef="Defect Priority Index">
          <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Defect Priority Index </th>
          <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindex | number}} </td>
        </ng-container>
        <!-- PDCA Column -->
        <ng-container matColumnDef="PDCA Status">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> PDCA Status </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.pdcastatus}} </td>
        </ng-container>
        <!-- Count Column -->
        <ng-container matColumnDef="Occurances">
          <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> Occurances </th>
          <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurances}} </td>
        </ng-container>
        <!-- Agreement Column -->
        <ng-container matColumnDef="Agreement">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Agreement </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.agreement}} </td>
        </ng-container>
        <!-- Remarks Column -->
        <ng-container matColumnDef="Remarks">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Remarks </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.remarks}} </td>
        </ng-container>
        <!-- User Column -->
        <ng-container matColumnDef="User">
          <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> User </th>
          <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.createdby}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="pojectStatusReportCol; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: pojectStatusReportCol;"></tr>
      </table>
    </div>
  </div>
  </div>
</div>
